import { render, staticRenderFns } from "./DialogDetailBaseProcess.vue?vue&type=template&id=46ac0af6"
import script from "./DialogDetailBaseProcess.vue?vue&type=script&lang=js"
export * from "./DialogDetailBaseProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports